/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function DropletFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="droplet-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 20.969C11.566 20.955 11.455 20.962 11.023 20.906C10.04 20.781 9.083 20.463 8.222 19.973C7.473 19.547 6.799 18.994 6.233 18.345C5.677 17.709 5.228 16.98 4.91 16.197C4.479 15.134 4.293 13.975 4.366 12.83C4.428 11.845 4.682 10.873 5.112 9.985C5.485 9.215 5.988 8.515 6.591 7.909C8.39 6.102 10.197 4.303 12 2.5C13.803 4.303 15.61 6.102 17.409 7.909C18.012 8.515 18.515 9.215 18.888 9.985C19.318 10.873 19.572 11.845 19.634 12.83C19.707 13.975 19.521 15.134 19.09 16.197C18.772 16.98 18.323 17.709 17.767 18.345C17.201 18.994 16.527 19.547 15.778 19.973C14.917 20.463 13.96 20.781 12.977 20.906C12.545 20.962 12.434 20.955 12 20.969ZM12.5 18.25C13.758 18.217 15.04 17.677 15.859 16.859C16.27 16.447 16.645 15.895 16.876 15.349C17.106 14.805 17.191 13.792 17.191 13.792L17.191 13.791C17.271 13.536 17.209 13.258 17.028 13.062C16.847 12.865 16.574 12.78 16.313 12.84C16.052 12.899 15.843 13.094 15.765 13.35C15.765 13.35 15.73 13.931 15.684 14.156C15.638 14.379 15.582 14.559 15.495 14.765C15.321 15.176 15.11 15.486 14.798 15.798C14.169 16.427 13.451 16.783 12.5 16.75C12.086 16.75 11.75 17.086 11.75 17.5C11.75 17.914 12.086 18.25 12.5 18.25Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M17.409 7.909C20.397 10.897 20.397 15.741 17.409 18.728C14.422 21.716 9.578 21.716 6.591 18.728C3.603 15.741 3.603 10.897 6.591 7.909L12 2.5L17.409 7.909Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
